'use strict';

/*@ngInject*/
module.exports = function ($rootScope, $scope, $translate, $anchorScroll, $location, platform, $http, urlFormats,$state, $window) {

    $rootScope.title = $translate.instant('pages.titles.index');

    // $scope.scrollTo = $stateParams.scrollTo;
    $scope.platform = platform;

    $scope.currentPlatform = $scope.platform.os.family.toLowerCase();
    $rootScope.searchData = '';
    $rootScope.affId = false;
    if($location.search().affid=='367' && $scope.currentPlatform === 'ios' && $location.search().data){
        $rootScope.affId = true;
    }
    if ($location.search().data) {
        $scope.androidDownloadLink = urlFormats.android.googlePlay + $location.search().data;
        $scope.iosDownloadLink = urlFormats.ios.appStore + $location.search().data;
        $scope.windowDownloadLink = urlFormats.windows.windowsStore+ "?name=SafeFamilySetup_"  + $location.search().data+".exe";
        $rootScope.searchData = $location.search().data;
    } else {
        $scope.androidDownloadLink = urlFormats.android.googleDefault;
        $scope.iosDownloadLink = urlFormats.ios.appstoreDefault;
        $scope.windowDownloadLink = urlFormats.windows.windowsDefault;
    }

    console.log($scope.currentPlatform);


    if($scope.currentPlatform === 'android' && $location.search().data){
        console.log("android");
       // window.location.href = $scope.androidDownloadLink;
        $location.path('/redirect');
    }else if($scope.currentPlatform === 'ios' && $location.search().data){
        console.log("ios");
        if($translate.use().indexOf('en')<-1){
            $location.path('/redirect');
        }else{
            $location.path('/');
        }
        //window.location.href = $scope.iosDownloadLink;
        // redirecting to landing page
        //$location.path('/redirect');

    }else if(($scope.currentPlatform.indexOf('windows') > -1) && $location.search().data){
        console.log("windows");
        // Adding GA event for automatic redirection from McAfee Home page
         /*window.ga('send', 'event', {
            eventCategory: 'Onboarding',
            eventAction: 'Windows Download - Landing page',
            eventLabel: 'Windows',
            'dimension1': 'download_landing_page',
            'dimension2': 'Lifecycle',
            'dimension6': 'true',
            'dimension4': 'true'
        });*/
        IntelSecurity.Analytics.Api.Track
            .event('download_landing_page')
            .feature("Lifecycle")
            .category("Onboarding")
            .action('Windows Download - Landing page')
            .label('Windows')
            .interactive(true)
            .userInitiated(true)
            .finish();
         $location.path('/redirect');
    }else if($location.search().data){
          $location.path('/undl');
    }


   //data=X83SQRS5XFGH2MH9&productkey=b677f7f8b9a9886756b0b14685dde0892a4b43592776021d7e61600f554b000e13295e4c5e24761963656d177f56510375142e4b&tp=48&affid=691&culture=en-gb 


    //$http.get($translate.instant('out-going-links.ios.appstore', params)).then(function (response) {
    //    $scope.iosDownloadLink = response;
    //});
    $scope.gaFunction = function(labelValue){         
        //window.ga('send', 'event','Onboarding', 'Windows Download - Landing page',labelValue,'download_landing_page', 'Lifecycle');
        /*window.ga('send', 'event', {
            eventCategory: 'Onboarding',
            eventAction: 'Windows Download - Landing page',
            eventLabel: labelValue,
            'dimension1': 'download_landing_page',
            'dimension2': 'Lifecycle',
            'dimension6': 'true',
            'dimension4': 'true'
        });*/
        IntelSecurity.Analytics.Api.Track
            .event('download_landing_page')
            .feature("Lifecycle")
            .category("Onboarding")
            .action('Windows Download - Landing page')
            .label(labelValue)
            .interactive(true)
            .userInitiated(true)
            .finish();
 //console.log("Download Page Called and page name: "+$scope.windowDownloadLink);
      //  window.open($scope.windowDownloadLink, '_self', 'location=yes');
        
    };
    $anchorScroll.yOffset = 80;
    $anchorScroll();
    $scope.getFromUrl = function () {
        return $location.absUrl();
    };
    $scope.getClientInfo = function () {
        return 'OS: ' + platform.os.family + ' browser:' + platform.name + ' desc: ' + platform.description;
    };

    // $scope.$on('$routeChangeSuccess', function () {
    //  if ($scope.scrollTo !== 'video') {
    //      $anchorScroll.yOffset = 80;     
    //          $location.hash($scope.scrollTo);
    //      $anchorScroll();
    //      }
    //      }); 



    // $scope.$on('$viewContentLoaded', function () {
    //  if ($scope.scrollTo !== 'video') {
    //      $anchorScroll.yOffset = 80;     
    //          $location.hash($scope.scrollTo);
    //      $anchorScroll();
    //      }
    //      }); 
    // getClientDeviceInfo();
    // function getClientDeviceInfo(){
    //     console.log("window value : ", $window);
    //     //console.log("Version : ",$window.core.version);
    //     console.log("DevicePixelRatio : ",$window.devicePixelRatio);
    //     console.log("Curent screen height : ",$window.innerHeight);
    //     console.log("Curent screen width : ",$window.innerWidth);
    //     console.log("1. AppName : ",$window.navigator.appCodeName);
    //     console.log("2. AppName : ",$window.navigator.appName);
    //     console.log("App Version : ",$window.navigator.appVersion);
    //     console.log("1. Connection  : ",$window.navigator.connection.downlink);
    //     console.log("2. Connection  : ",$window.navigator.connection.effectiveType);
    //     console.log("3. Connection  : ",$window.navigator.connection.onchange);
    //     console.log("4. Connection  : ",$window.navigator.connection.rtt);
    //     console.log("Device Memory : ",$window.navigator.deviceMemory);
    //     console.log("Language : ",$window.navigator.language);
    //     console.log("Avilable language : ",$window.navigator.languages);
    //     console.log("Platform : ",$window.navigator.platform);
    //     console.log("Product Name : ",$window.navigator.product);
    //     console.log("Product sub : ",$window.navigator.productSub);
    //     console.log("User Agent : ",$window.navigator.userAgent);
    //     console.log("Vender Name : ",$window.navigator.vendor);
    //     console.log("ScreenHeight : ",$window.screen.height);
    //     console.log("PixelDepth : ",$window.screen.pixelDepth);
    //     console.log("Width : ",$window.screen.width);
    //     console.log("ColorDepth : ",$window.screen.colorDepth);
    //     console.log("Time Zone :", new Date().getTimezoneOffset())
    //     // get ip info
    //     $http({
    //         method: 'GET',
    //         url: "https://api.ipify.org?format=json"
    //     }).then(function(response) {  // this callback will be called asynchronously when the response is available
    //         console.log("Ip address :", response.data.ip);
    //     },function(response) {         // called asynchronously if an error occurs or server returns response with an error status.
    //         console.log("Error while calling encryption API : ", response.data);
    //     });
    
    // };
};
